import React from "react";
import jdata from "./data.json"; 

const Navigation = ({lang}) => {
  const data = jdata.Header;
  //alert(data.company)
  return (
        
        <ul id="menu">
            <a id="Logo" href="https://www.tech2us.ma" label={jdata.company}>
              <img alt={jdata.company} title={jdata.description} className="logo" src={data.logo} style={{paddingBottom: '.3rem', margin:0}}/>
            </a>
            <li style={{marginLeft:'8rem'}}>
              <a href="#about">
                About
              </a>
            </li>
            <li>
              <a href="#services">
                Services
              </a>
            </li>
            <li>
              <a href="#gallery">
                Gallery
              </a>
            </li>
            <li>
              <a href="#team">
                Team
              </a>
            </li>
            <li>
              <a href="#contact">
                Contact
              </a>
            </li>
          </ul>
  );
};

export {Navigation};
